/* app/js/src/components/mam-explorer/mam-explorer-toolbar/mam-explorer-toolbar.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.mam-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
  gap: 16px;
  border-bottom: 1px solid rgb(226, 232, 241);
  flex-wrap: wrap;
}
.mam-toolbar__actions {
  display: flex;
  gap: 8px;
}
.mam-toolbar__btn {
  padding: 7px 16px;
  border: 1px solid rgb(226, 232, 241);
  border-radius: 4px;
  background-color: #ffffff;
  color: rgb(35, 47, 58);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.15s;
}
.mam-toolbar__btn:hover {
  background-color: #eef2f6;
}
.mam-toolbar__btn--primary {
  background-color: rgb(45, 187, 252);
  color: #ffffff;
  border-color: rgb(45, 187, 252);
}
.mam-toolbar__btn--primary:hover {
  background-color: rgb(41, 170, 229);
}
.mam-toolbar__filters {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
}
.mam-toolbar__search {
  flex: 1;
  min-width: 180px;
  padding: 7px 12px;
  border: 1px solid rgb(226, 232, 241);
  border-radius: 4px;
  font-size: 13px;
  color: rgb(35, 47, 58);
  background-color: #ffffff;
  outline: none;
}
.mam-toolbar__search::placeholder {
  color: rgb(194, 204, 219);
}
.mam-toolbar__search:focus {
  border-color: rgb(45, 187, 252);
}
.mam-toolbar__select {
  padding: 7px 12px;
  border: 1px solid rgb(226, 232, 241);
  border-radius: 4px;
  font-size: 13px;
  color: rgb(35, 47, 58);
  background-color: #ffffff;
  cursor: pointer;
  outline: none;
}
.mam-toolbar__select:focus {
  border-color: rgb(45, 187, 252);
}
/*# sourceMappingURL=mam-explorer-toolbar.component.css.map */
